export default {
  create_title: 'Adaugă endpoint webhook',
  edit_title: 'Editează endpoint webhook',
  form: {
    url: 'URL endpoint HTTPS',
    description: 'Descriere',
    description_placeholder: 'ex. Evenimente comandă pentru POS',
    events: 'Evenimente de livrat',
    events_required: 'Selectează cel puțin un eveniment.',
    events_hint: 'Doar evenimentele selectate sunt livrate la acest endpoint.',
    events_selected: '{{selected}} din {{total}}',
    event_groups: {
      order: 'Comenzi',
      store: 'Magazin',
      product: 'Produse',
      modifier: 'Modificatori',
      menu_push: 'Publicări meniu',
      payout: 'Plăți',
    },
    status: 'Stare',
    status_active: 'Activ',
    status_disabled: 'Dezactivat',
    status_auto_disabled: 'Auto-dezactivat (alege Activ pentru reactivare)',
  },
  buttons: {
    cancel: 'Anulează',
    create: 'Creează',
    save: 'Salvează',
  },
  toasts: {
    created: 'Endpoint creat.',
    updated: 'Endpoint actualizat.',
    error: 'Endpoint-ul nu a putut fi salvat. Te rugăm să încerci din nou.',
  },
};
